import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export const getAvailablePSPIndexes = (engagementId, actionProps) => {
	const URL = Env.getBaseURL(serviceURL, engagementId) + 'PSPIndexes';
	return {
		type: types.GET_AVAILABLE_PSP_INDEXES,
		...actionProps,
		meta: {
			api: {
				url: URL,
				method: 'GET'
			}
		}
	};
};
